import { render, staticRenderFns } from "./TaskDetailsModal.vue?vue&type=template&id=650ed5fe"
import script from "./TaskDetailsModal.vue?vue&type=script&lang=js"
export * from "./TaskDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./TaskDetailsModal.vue?vue&type=style&index=0&id=650ed5fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports